import React from 'react';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';

import { DateFilter } from '@rivallapp/volosports-components';
import useDiscoverStore from '../../../../../zustand-stores/DiscoverStore';
import { DateFormat } from '../../../../../zustand-stores/DiscoverStore/helpers/formatDateRangeForQuery';
import { useUrlParams } from '../../../../../hooks';

const propTypes = {
  dateLow: PropTypes.shape({
    isValid: PropTypes.func,
  }),
  dateHigh: PropTypes.shape({
    isValid: PropTypes.func,
  }),
};
const defaultProps = {
  dateLow: undefined,
  dateHigh: undefined,
};

const DiscoverDateFilter = () => {
  const { updateUrlParams } = useUrlParams();

  const dateLow = useDiscoverStore(store => store.filters.dateLow);
  const dateHigh = useDiscoverStore(store => store.filters.dateHigh);

  const onConfirmDates = (low, high) => {
    const formattedDateLow = low.format(DateFormat);
    const formattedDateHigh = high.format(DateFormat);
    updateUrlParams({ dateLow: formattedDateLow, dateHigh: formattedDateHigh });
  };

  const onClearDates = () => {
    updateUrlParams({ dateLow: undefined, dateHigh: undefined });
  };

  return (
    <DateFilter
      dateLow={dateLow ? moment(dateLow, DateFormat) : null}
      dateHigh={dateHigh ? moment(dateHigh, DateFormat) : null}
      onClear={onClearDates}
      onConfirm={onConfirmDates}
    />
  );
};

DiscoverDateFilter.propTypes = propTypes;
DiscoverDateFilter.defaultProps = defaultProps;

export default DiscoverDateFilter;
